export const brandAssets = {
  certn: { name: "Certn", primary: "#1bb793", secondary: "#134247" },
  mycrc: { name: "MyCRC", primary: "#f9b64a", secondary: "#134247" },
  lime: { name: "Lime", primary: "#8dc867", secondary: "#134247" },
};

export type CascadiaBrandAsset = keyof typeof brandAssets;
